export const environment = {
  apiConnectURL: "https://api-hml.fgc.org.br/app/portalpj",
  apiConnectDpgeURL: "https://api-hml.fgc.org.br/app/portalpj-dpge",
  apiConnectAppUrl: "https://api-hml.fgc.org.br/app",
  privacyPolicy: "https://www.fgc.org.br/documents/d/asset-library-52554/politica-de-privacidade-do-fgc-1",
  production: false,
  cognito: {
    UserPoolId: "us-east-1_Ws1omSuZK",
    ClientId: "s9qkeb2risnh0r91g6vihkknf",
  },
};
